import {Compass, Users, MessageCircle, CalendarDays, Sparkles, UserRound, Settings, Package, Flower2, Store, Rss} from "lucide-react";

export const NAV_ITEMS = [
  ["Home", "home", Compass],
  ["My feed", "feed", Rss],
  ["Events around", "events", CalendarDays],
  ["Panchang", "panchang", Sparkles],
  ["Profile", "profile", UserRound],
  ["Admin studio", "admin", Settings],
];

export const SECTION_TILES = [
  ["Bazaar", "bazaar", Store, "Authentic products, reviewed"],
  ["Samaj", "samaj", Users, "Apna loko, near and far"],
  ["Ask My Community", "ask", MessageCircle, "Puchho, the community answers"],
  ["Your Personal Concierge", "gfi", Package, "Anything handled, anywhere"],
  ["Culture", "culture", Flower2, "Rashifal, choghadiya & more"],
];

export const LIFESTYLE_TOPICS = [
  "Food & Dining","Parenting","Travel","Finance","Culture","Health & Wellness","Education",
  "Spirituality","Business","Tech","Fashion & Style","Home & Decor","Weddings & Events",
  "Fitness","Beauty","Books & Arts","Relationships","Career","Automobiles","Pets",
  "Shopping","Festivals","Real Estate","Legal","Elderly Care"
];

export const MARKET_CATEGORIES = [
  "Apparel & Accessories","Gems & Jewellery","Home & Decor","Handicrafts & Art",
  "Food & Snacks","Ayurveda & Wellness","Puja & Spiritual","Kids & Gifting"
];

export const TRADITIONS = ["Vaishnava","Smarta","Madhva","Shaiva","Shakta","Lingayat"];

export const COMMUNITY_COLORS = ["coral", "teal", "saffron"];

export const SEED_LISTINGS = [
  {listing_id: "l1", name: "Malabar Spice House", category: "Food & Craft", location: "Kochi · Ships worldwide", description: "Single-origin spices and pantry staples sourced from family farms.", tags: ["heritage", "shipping"], rating: 4.9, reviews: 86, phone: "+91 484 221 4090", opening_hours: "Mon–Sat · 9:00–19:00", service_area: "Kochi + worldwide shipping", is_open: true, image: "https://images.unsplash.com/photo-1596040033229-a9821ebd058d?auto=format&fit=crop&w=800&q=80"},
  {listing_id: "l2", name: "Ceylon Loom", category: "Home & Design", location: "Colombo · Global delivery", description: "Handwoven linens and contemporary heirloom pieces.", tags: ["handmade", "home"], rating: 4.8, reviews: 42, phone: "+94 11 298 3200", opening_hours: "Mon–Fri · 10:00–18:00", service_area: "Sri Lanka + global delivery", is_open: true, image: "https://images.unsplash.com/photo-1600862754152-80a263dd564f?auto=format&fit=crop&w=800&q=80"},
  {listing_id: "l3", name: "Coastal Ceremonies", category: "Events & Travel", location: "Goa · Mauritius · Dubai", description: "Beautifully considered celebrations for gatherings across the diaspora.", tags: ["events", "concierge"], rating: 5.0, reviews: 112, phone: "+971 4 281 7700", opening_hours: "Daily · 8:00–21:00", service_area: "Goa · Mauritius · Dubai", is_open: true, image: "https://images.unsplash.com/photo-1519167758481-83f550bb49b3?auto=format&fit=crop&w=800&q=80"},
];
